t = require('views/internal/teacup-with-helpers')('popover_change_labels')

module.exports = ->
  t.input '.js-autofocus.js-label-search', { type: 'text', placeholder: t.l('search-labels-ellipsis'), value: t.mustacheVar('searchInit'), autocomplete: 'off' }

  t.ul '.edit-labels-pop-over.js-labels-list'

  t.mustacheBlock '__ed', ->
    t.div ->
      t.a '.quiet-button.full.js-add-label', { href: '#' }, ->
        t.format 'create-a-new-label'
      t.a '.quiet-button.full.hide.js-show-more', { href: '#' }, ->
        t.format 'show-more-labels'
      t.hr()
      t.a '.quiet-button.full.js-toggle-color-blind-mode', { href: '#' }, ->
        t.mustacheBlock 'isColorBlindEnabled', ->
          t.format 'disable-color-blind-friendly-mode'
        t.mustacheBlockInverted 'isColorBlindEnabled', ->
          t.format 'enable-color-blind-friendly-mode'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/popover_change_labels.coffee